// Supported annotations found in the 164 Adorans sample songbooks.
const labels = {
  artist: '', tag: '', album: 'Album', bpm: 'BPM', meter: 'Metrum',
  feel: 'Rytm', tempo: 'Tempo', giszowiec: 'Giszowiec',
  'giszowiec taize': 'Giszowiec Taizé', salwator: 'Salwator',
  msza: 'Msza', note: 'Uwagi',
};

export const bracketAnnotation = line => line?.type === 'text' &&
  typeof line.content === 'string' ? line.content.match(/^\s*\[(.+)\]\s*$/) : null;

// These are lyric structure markers, not song metadata. Keep them in the body.
export const isSectionAnnotation = line => {
  const match = bracketAnnotation(line);
  return !!match && /^(?:ref(?:ren)?|pre-ref|chorus|zwrotk[ai]|zwr|verse|v|z|bridge|mostek|most|intro|outro|coda|wstęp|zakończenie|interludium|modlitwa|solówki|zaczynają|powtórzka)(?=$|[\s\d:.(])/i.test(match[1]);
};

export const isSongAnnotation = line => !!bracketAnnotation(line) && !isSectionAnnotation(line);

export const songHeaderMetadata = song => {
  const entries = [];
  const seen = new Set();
  for (const line of song.lines || []) {
    if (line.type !== 'text' || typeof line.content !== 'string') continue;
    const match = line.content.match(/^\s*\[([^\]:]+):\s*(.*?)\]\s*$/);
    if (!match) continue;
    const key = match[1].trim().toLowerCase();
    const value = match[2].trim();
    if (!value || (key !== 'url' && (value.includes('[') || value.includes(']')))) continue;
    const identity = key + ':' + value.toLocaleLowerCase('pl');
    if (seen.has(identity)) continue;
    seen.add(identity);
    if (key === 'url') {
      try {
        const url = new URL(value);
        if (!['http:', 'https:'].includes(url.protocol)) continue;
        entries.push({key, value, url: value, youtube: /(^|\.)youtube\.com$|^youtu\.be$/i.test(url.hostname)});
      } catch { /* Invalid links stay in the source, without a visible annotation. */ }
    } else if (Object.prototype.hasOwnProperty.call(labels, key)) {
      const displayValue = key === 'feel' ? ({straight: 'prosty', swing: 'swing'}[value.toLowerCase()] || value) : value;
      entries.push({key, value, text: labels[key] ? `${labels[key]}: ${displayValue}` : displayValue});
    }
  }
  return entries;
};
